import { render, staticRenderFns } from "./BackupInProgressModal.vue?vue&type=template&id=53f2ec43&lang=pug"
import script from "./BackupInProgressModal.vue?vue&type=script&lang=js"
export * from "./BackupInProgressModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports